import { useState } from "react"
import DashboardHeader from "../../components/dashboard/HeaderDashboard"
import FormSection from "../../components/ui/FormSection"
import FormInput from "../../components/layout/FormInput"
import Button from "../../components/ui/Button"
import PatientSidebar from "../../components/dashboard/PatientSidebar"
import Modal from "@/components/ui/Modal";
import NavigationService from "@services/navigation.service.js";
import AuthController from "@controllers/auth.controller.js";


export default function PatientSettings() {

const [activeTab, setActiveTab] = useState("User information")
const [showWelcomeModal, setShowWelcomeModal] = useState(true)

 // User information state
 const [userInfo, setUserInfo] = useState({
    firstName: "Odile",
    lastName: "Deray",
    contactNumber: "+32 494 61 69 19",
    addressStreet: "Avenue de la peur",
    addressNumber: "10",
    country: "Belgium",
    city: "Bruxelles",
    postalCode: "1000",
  })

  // Security state
  const [security, setSecurity] = useState({
    password: "",
    confirmPassword: "",
  })

  // Password validation state
  const [passwordError, setPasswordError] = useState("")

   // Handle user info input change
   const handleUserInfoChange = (e) => {
    const { name, value } = e.target
    setUserInfo((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  // Handle security input change
  const handleSecurityChange = (e) => {
    const { name, value } = e.target
    setSecurity((prev) => ({
      ...prev,
      [name]: value,
    }))

    // Clear password error when typing
    if (passwordError) {
        setPasswordError("")
      }
    }

    // Update user information
  const handleUpdateUserInfo = () => {
    console.log("Updating user information:", userInfo)
    alert("User information updated successfully!")
  }

  // Update password
  const handleUpdatePassword = () => {
    // Validate passwords
    if (security.password.length < 8) {
      setPasswordError("Password must be at least 8 characters long")
      return
    }

    if (security.password !== security.confirmPassword) {
      setPasswordError("Passwords do not match")
      return
    }

    console.log("Updating password")

    // Reset form
    setSecurity({
      password: "",
      confirmPassword: "",
    })

    // Show success message
    alert("Password updated successfully!")
  }

  // Handle sign out
  const handleSignOut = () => {
    AuthController.logout();
  }

  const tabButtons = ["User information", "Security"]

  return (
    <div className="flex h-screen overflow-hidden">
      {" "}
      <PatientSidebar
        patientName={userInfo.firstName + " " + userInfo.lastName}
        onSignOut={handleSignOut}
        showSignature={false}
        showQRCode={false}
        showSettings={true} 
      />
      <div className="flex-1 flex flex-col overflow-hidden">
        {" "}
        {/* Main content area */}
        <DashboardHeader
          title="Settings"
          buttons={tabButtons}
          activeButton={activeTab}
          onButtonClick={(tab) => setActiveTab(tab)}
        />
        <div className="flex-1 overflow-auto bg-dashboard-bg">
          <div className="flex-1 mt-2 rounded-xl bg-dashboard-bg1">
            {/* User Information Tab */}
            {activeTab === "User information" && (
              <main className="p-3 sm:p-4 md:p-6">
                <FormSection title="User information">
                  <div className="flex flex-col md:flex-row">
                    {/* Form inputs - 2/3 width */}
                    <div className="md:w-2/3 pr-6">
                      {/* First name and Last name */}
                      <div className="flex flex-col md:flex-row gap-4 mb-4">
                        <div className="flex-1">
                          <FormInput
                            label="First name"
                            name="firstName"
                            value={userInfo.firstName}
                            onChange={handleUserInfoChange}
                          />
                        </div>
                        <div className="flex-1">
                          <FormInput
                            label="Last name"
                            name="lastName"
                            value={userInfo.lastName}
                            onChange={handleUserInfoChange}
                          />
                        </div>
                      </div>

                      {/* Address - Street and Number */}
                      <div className="flex flex-col md:flex-row gap-4 mb-4">
                        <div className="flex-grow">
                          <FormInput
                            label="Address - Street"
                            name="addressStreet"
                            value={userInfo.addressStreet}
                            onChange={handleUserInfoChange}
                          />
                        </div>
                        <div className="md:w-1/4">
                          <FormInput
                            label="Number"
                            name="addressNumber"
                            value={userInfo.addressNumber}
                            onChange={handleUserInfoChange}
                          />
                        </div>
                      </div>

                      {/* Country, City / Town, Postal code */}
                      <div className="flex flex-col md:flex-row gap-4 mb-4">
                        <div className="flex-1">
                          <FormInput
                            label="Country"
                            name="country"
                            value={userInfo.country}
                            onChange={handleUserInfoChange}
                          />
                        </div>
                        <div className="flex-1">
                          <FormInput
                            label="City / Town"
                            name="city"
                            value={userInfo.city}
                            onChange={handleUserInfoChange}
                          />
                        </div>
                        <div className="flex-1">
                          <FormInput
                            label="Postal code"
                            name="postalCode"
                            value={userInfo.postalCode}
                            onChange={handleUserInfoChange}
                          />
                        </div>
                      </div>

                      {/* Contact number */}
                      <div className="mb-4">
                        <FormInput
                          label="Contact number"
                          name="contactNumber"
                          type="tel"
                          value={userInfo.contactNumber}
                          onChange={handleUserInfoChange}
                        />
                      </div>

                      <div className="p-6 flex justify-center">
                        <Button
                          onClick={handleUpdateUserInfo}
                          variant="addbutton"
                          className="w-[50%] text-white font-bold"
                        >
                          Update information
                        </Button>
                      </div>
                      <div className="h-20"></div>
                      <div className="h-10"></div>
                    </div>

                    {/* Logo section - 1/3 width */}
                    <div className="md:w-1/3 flex flex-col items-center">
                      <div className="w-82 h-82 mt-4">
                        <img src="/img/logo2.png" alt="Oshimed Logo" className="w-full h-full object-contain" />
                      </div>
                    </div>
                  </div>
                </FormSection>
              </main>
            )}
            
            {/* Security Tab */}
            {activeTab === "Security" && (
              <main className="p-3 sm:p-4 md:p-6">
                <FormSection title="Security">
                  <div className="flex flex-col md:flex-row">
                    {/* Form inputs - 2/3 width */}
                    <div className="md:w-2/3 pr-6">
                      <h3 className="text-lg font-semibold mb-2">Set a new password</h3>
                      <p className="text-gray-600 mb-4">Your password secure your access to your account.</p>
                      <p className="text-gray-600 mb-6">
                        If you lose your password, you can't retrieve it via your email address.
                      </p>

                      <div className="mb-4 w-[50%]">
                        <FormInput
                          label="Password"
                          name="password"
                          type="password"
                          value={security.password}
                          onChange={handleSecurityChange}
                          placeholder="At least 8 characters"
                        />
                      </div>

                      <div className="mb-4 w-[50%]">
                        <FormInput
                          label="Re-enter password"
                          name="confirmPassword"
                          type="password"
                          value={security.confirmPassword}
                          onChange={handleSecurityChange}
                          placeholder="At least 8 characters"
                        />
                      </div>

                      {/* Password Error */}
                      {passwordError && <div className="mt-2 text-red-500">{passwordError}</div>}

                      <div className="mt-6">
                        <Button
                          onClick={handleUpdatePassword}
                          variant="addbutton"
                          className="w-[50%] text-white font-bold"
                        >
                          Update password
                        </Button>
                      </div>
                    </div>

                    {/* Logo section - 1/3 width */}
                    <div className="md:w-1/3 flex flex-col items-center">
                      <div className="w-82 h-82 mt-4">
                        <img src="/img/logo2.png" alt="Oshimed Logo" className="w-full h-full object-contain" />
                      </div>
                    </div>
                  </div>
                  <div className="h-20"></div>
                  <div className="h-20"></div>
                </FormSection>
              </main>
            )}
          </div>
        </div>
      </div>
      {/* Welcome Modal */}
      <Modal
        isOpen={showWelcomeModal}
        onClose={() => setShowWelcomeModal(false)}
        title="Welcome to your account"
        primaryAction={() => setShowWelcomeModal(false)}
        primaryActionLabel="Continue"
        size="max"
      >
        <p className="mb-4">
          You are now connected to your personal space. Please note that this space only allows you to manage your
          profile settings.
        </p>
        <p className="mb-4">
          To participate in a clinical study, you will receive an email from the investigator containing:
        </p>
        <ul className="list-disc list-inside mb-4 pl-4">
          <li>A secure link to review and sign the informed consent form</li>
          <li>A personal QR code to bring with you when attending the clinical site</li>
        </ul>
        <p className="mb-4">Make sure to check your Inbox (and spam folder) for emails from the study team.</p>
        <p className="mb-4">If you have not received anything yet, please wait to be contacted by your investigator.</p>
      </Modal>
    </div>
  )
}
